export default "__VITE_ASSET__3352d45b__"